import z from "zod"

export const DateSchema = z
  .union([z.string().date(), z.date()])
  .transform((d) => (d instanceof Date ? d.toISOString().split('T')[0] : d))
  .optional()
  .nullable()

export const DateTimeSchema = z
  .preprocess((value) => {
    if (value === undefined || value === null || value instanceof Date) {
      return value
    }

    // if provided value is a string or number type, try parse as date
    if (typeof value === 'string' || typeof value === 'number') {
      const date = new Date(value)

      return Number.isNaN(date.getTime()) ? undefined : date
    }

    return undefined
  }, z.date())
  .transform((date: Date) => date.toISOString())

export const QueryBooleanSchema = z.preprocess(
  (val) => val === '1' || val === 1 || val === true || val === 'true',
  z.boolean(),
)

// allows both 04 and +614
const AUSTRALIAN_MOBILE_REGEX = /^(?:\+?61|0)4\d{8}$/
export const AustralianMobileSchema = z.string()
  .max(10)
  .transform((val) => val.replace(/[\s\-()]/g, ""))
  .refine((val) => AUSTRALIAN_MOBILE_REGEX.test(val), {
    message: "Please enter a valid Australian mobile number (e.g., 0412345678)",
  })
